import { cuverseApi } from 'store/api/cuverse-api/cuverse.api';

import { PurchaseRoute } from './purchase.route';

export const requestActiveMiners = async (): Promise<unknown> =>
  cuverseApi.get(PurchaseRoute.Miners()).then((res) => res?.data);

export const requestActiveTrialMiners = async (): Promise<unknown> =>
  cuverseApi.get(PurchaseRoute.TrialMiners()).then((res) => res?.data);

export const requestIsFirstPurchase = async (): Promise<unknown> =>
  cuverseApi.get(PurchaseRoute.FirstPurchase()).then((res) => res?.data);
